var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tooltip',{staticClass:"BbField",class:{[_vm.errorClass]: _vm.isErrorDisplayed},attrs:{"text":_vm.lastTooltipMessage,"tag":_vm.tag,"target":_vm.$el,"trigger":"manual","placement":_vm.tooltipPlacement},model:{value:(_vm.showTooltip),callback:function ($$v) {_vm.showTooltip=$$v},expression:"showTooltip"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }